<div *ngIf="model && model.IntUser">


    <input autocomplete="false" name="hidden" type="text" style="display:none;">
    <div class="card">
        <!-- <div class="card-header text-center">
            <h5>{{boxTitle}}</h5>
        </div> -->
        <div class="card-body">

            <ul class="nav nav-tabs" id="intUserTabs" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" data-bs-toggle="tab" data-bs-target="#tabGeneral" type="button" role="tab"
                        aria-controls="home">
                        Données générales
                        <i *ngIf="frmGeneral.dirty && !readOnly" class="fas fa-edit ml-2 text-warning"></i>
                        <i *ngIf="frmGeneral.invalid && !inputControlReadonly" class="fas fa-exclamation-circle ml-2 text-danger"></i>
                    </a>
                </li>
                <li class="nav-item" [hidden]="createMode">
                    <a class="nav-link" [ngClass]="{'disabled': (!perimetersRequired)}" data-bs-toggle="tab"
                        data-bs-target="#tabPerimetres" type="button" role="tab"
                        aria-controls="tabPerimetres">
                        Périmètres
                        <i *ngIf="perimetersRequired && frmPerimeters.dirty && !readOnly" class="fas fa-edit ml-2 text-warning"></i>
                        <i *ngIf="perimetersRequired && frmPerimeters.invalid && !readOnly" class="fas fa-exclamation-circle ml-2 text-danger"></i></a>
                </li>
                <!-- <li class="nav-item" *ngIf="!createMode">
                    <a class="nav-link" [ngClass]="{'disabled': ( !familiesRequired)}" data-bs-toggle="tab"
                        data-target="#tabFamilles" type="button" role="tab" aria-controls="tabFamilles">
                        Familles
                        <i *ngIf="familiesRequired && frmFamilies.dirty && !readOnly" class="fas fa-edit ml-2 text-warning"></i>
                        <i *ngIf="familiesRequired && frmFamilies.invalid && !inputControlReadonly" class="fas fa-exclamation-circle ml-2 text-danger"></i>
                    </a>
                </li> -->
            </ul>

            <div class="tab-content mt-3">
                <div class="tab-pane fade show active" id="tabGeneral">
                    <form name="frmGeneral" #frmGeneral="ngForm" autocomplete="off">
                        <div class="row" *ngIf="model.IntUserStatutHistory">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">GID</label>
                                    <input type="text" name="UtiGid" class="form-control" [disabled]="inputControlReadonly" required
                                        [(ngModel)]="model.IntUser.UtiGid" maxlength="80">
                                </div>
                            </div>
                            <div *ngIf="!createMode" class="col-md-3 pt-3">
                                <switchery-ios label="Bloqué" [(ngModel)]="isLocked" size="medium" name="isLocked"></switchery-ios>
                                <!-- <ng-switchery [(ngModel)]="isLocked" size="switchery-sm" name="isLocked" [disabled]="readOnly" 
                                    onLabel="Bloqué" offLabel="Actif" color="switchery-danger">
                                </ng-switchery> -->
                            </div>
                            <div *ngIf="isLocked" class="col">
                                <div class="form-group">
                                    <label class="control-label">Motif</label>
                                    <input *ngIf="inputControlReadonly" name="statutComment" class="form-control flex-grow" required [disabled]="readOnly" 
                                        [(ngModel)]="statutComment">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Email</label>
                                    <input type="email" name="EmailDiff" class="flex-grow form-control"
                                        [disabled]="inputControlReadonly" required [(ngModel)]="model.IntUser.Contact.EmailDiff"
                                        maxlength="254" email>
                                </div>
                            </div>
                            <div class="col-md-3" *ngIf="isAlreadyModified">
                                <div class="form-group">
                                    <label class="control-label">Modifié le</label>
                                    <label class="form-control">{{model.IntUserStatutHistory.DatMaj | date :'dd/MM/yyyy HH:mm'}}</label>
                                </div>
                            </div>
                            <div class="col-md-3" *ngIf="isAlreadyModified">
                                <div class="form-group">
                                    <label class="control-label">Par</label>
                                    <label class="form-control">{{UserMajLib}}</label>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label">Civilité</label>
                                    <paf-combobox 
                                         class="flex-grow" style="width:100%;" [required]="true" name="civility"
                                        [disabled]="inputControlReadonly" [(ngModel)]="model.IntUser.Contact.Civility"
                                        [data]="sharedDataSvc.civilities">
                                    </paf-combobox> 
                                    <!-- <app-civilities class="flex-grow" style="width:100%;" [required]="true" name="civility"
                                        [disabled]="inputControlReadonly" [(ngModel)]="model.IntUser.Contact.CivId" [noHeader]="true">
                                    </app-civilities> -->

                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label">Nom</label>
                                    <input type="text" name="Lastname" class="flex-grow form-control"
                                        [disabled]="inputControlReadonly" required [(ngModel)]="model.IntUser.Contact.Lastname"
                                        maxlength="80">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label">Prénom</label>
                                    <input type="text" name="Firstname" class="flex-grow form-control"
                                        [disabled]="inputControlReadonly" required [(ngModel)]="model.IntUser.Contact.Firstname"
                                        maxlength="80">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label">Fonction</label>
                                    <input type="text" name="Fonction" class="flex-grow form-control"
                                        [disabled]="inputControlReadonly" [(ngModel)]="model.IntUser.Contact.Fonction" maxlength="128">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label">Téléphone</label>
                                    <input type="text" name="Phone" class="flex-grow form-control" [disabled]="inputControlReadonly"
                                        [(ngModel)]="model.IntUser.Contact.Phone" maxlength="32">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label">Mobile</label>
                                    <input type="text" name="CellPhone" class="flex-grow form-control"
                                        [disabled]="inputControlReadonly" [(ngModel)]="model.IntUser.Contact.CellPhone" maxlength="32">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="control-label">Profil</label>
                                    <paf-combobox
                                        [data]="lstProfils" style="width:100%;" name="ProfilId" [required]="true"
                                        [disabled]="inputControlReadonly || isSelf" [(ngModel)]="model.IntUser.ProfilId"
                                        (selectedObjectChange)="reloadLstReferents()"
                                        [bindToId]="true"></paf-combobox>
                                </div>
                            </div>
                            <div class="col-md-6" *ngIf="referentRequis">
                                <div class="form-group">
                                    <label class="control-label">Référent</label>
                                    <paf-combobox
                                        [data]="lstReferents" style="width:100%;" name="AchRefId" [required]="model.IntUser.AchRefId!=0"
                                        [disabled]="inputControlReadonly" [(ngModel)]="acheteurReferent"
                                        [displayFn]="displayReferent">
                                    </paf-combobox>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">Commentaire</label>
                                    <textarea name="Observations" rows="3" style="min-height:50px;"
                                        class="form-control flex-grow" [disabled]="inputControlReadonly"
                                        [(ngModel)]="model.IntUser.Observations"></textarea>
                                </div>
                            </div>
                        </div>

                    </form>
                </div>
                <div class="tab-pane fade" id="tabPerimetres"  [hidden]="createMode">
                    <form name="frmPerimeters" #frmPerimeters="ngForm" autocomplete="off">
                        <div class="row my-2" *ngIf="perimetersRequired">
                            <div class="col-6 d-flex flex-column">
                                <label class="control-label">Sociétés</label>
                                <kendo-multiselect class="form-control" 
                                    name="Socs" [data]="socsDispo"
                                    style="width:100%;" 
                                    required 
                                    [filterable]="true" 
                                    [(ngModel)]="selectedSocs" 
                                    [ngModelOptions]="{ standalone: true }"
                                    [disabled]="isAdmin||inputControlReadonly"
                                    textField="SocLib" 
                                    valueField="SocCod" 
                                    (valueChange)="onSocsChange($event)"
                                    #cboSocs>
                                </kendo-multiselect>
                                <pre *ngIf="sharedDataSvc.debug">
                                    selectedSocs = {{selectedSocs |json}}
                                </pre>
                            </div>
                            <div class="col-6 d-flex flex-column">
                                <label class="control-label">Etablissements</label>
                                <kendo-multiselect 
                                    class="form-control" 
                                    name="Etbs" 
                                    [data]="etbsDispo" 
                                    [disabled]="isAdmin||inputControlReadonly"
                                    style="width:100%;" 
                                    required 
                                    [filterable]="true" 
                                    [(ngModel)]="model.Etbs"
                                    [ngModelOptions]="{ standalone: true }"
                                    textField="EtbLib" 
                                    valueField="EtbLib"                                    
                                    (valueChange)="onEtbsChange($event)" 
                                    #cboEtbs>
                                </kendo-multiselect>
                                <pre *ngIf="sharedDataSvc.debug">
                                    model.Etbs = {{model.Etbs |json}}
                                </pre>
                            </div>
                        </div>
                    </form>

                </div>
                <!-- <div class="tab-pane fade" id="tabFamilles"   [hidden]="createMode">
                    <form name="frmFamilies" #frmFamilies="ngForm" autocomplete="off">
                        <div class="row my-2" *ngIf="familiesRequired">
                            <div class="col-8 offset-2 d-flex flex-column">
                                <label class="control-label">Familles</label>
                                <kendo-multiselect class="form-control" name="Familles" [data]="lstFamiliesWithStar" required [disabled]="isAdmin||inputControlReadonly"
                                    style="width:100%;" [filterable]="true" [(ngModel)]="model.IntUser.Families"
                                    textField="Segment" valueField="Cod" #cboFamilies>
                                    <ng-template kendoMultiSelectTagTemplate let-dataItem>
                                        {{familyDisplay(dataItem)}}
                                    </ng-template>
                                    <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                        {{familyDisplay(dataItem)}}
                                    </ng-template>
                                </kendo-multiselect>
                                <pre *ngIf="sharedDataSvc.debug">
                                    intUser.Families = {{model.IntUser.Families |json}}
                                </pre>
                                <pre *ngIf="sharedDataSvc.debug">
                                    lstFamiliesWithStar = {{lstFamiliesWithStar |json}}
                                </pre>
                            </div>
                        </div>
                    </form>

                </div> -->

            </div>
            <div class="text-center">
                <button type="button" class="btn btn-sm btn-warning mx-1" (click)="annuler()">Annuler</button>
                <button *ngIf="createMode && !readOnly" type="commit" class="btn btn-sm btn-success mx-1"
                    [disabled]="frmGeneral.invalid" (click)="continuer()">Continuer</button>
                <button *ngIf="!createMode && !readOnly" [disabled]="!canDelete.Ok" type="button" class="btn btn-sm btn-danger mx-1" (click)="supprimer()" data-toggle="tooltip" [title]="canDelete.Message">Supprimer</button>
                <button *ngIf="!createMode && !readOnly" type="commit" class="btn btn-sm btn-primary mx-1"
                    [disabled]="frmGeneral.invalid || (perimetersRequired && frmPerimeters.invalid && !inputControlReadonly) || (familiesRequired && frmFamilies.invalid && !inputControlReadonly)"
                    (click)="valider()">Valider</button>
            </div>
            <pre *ngIf="sharedDataSvc.debug">
                createMode = {{createMode}}
            </pre>
            <pre *ngIf="sharedDataSvc.debug">
                model = {{model |json}}
            </pre>
        </div>
    </div>
</div>